module.exports = __webpack_public_path__ + "static/img/h_48@2x.131e3440.png";